import { useLayoutEffect } from 'react';

export const useAutoResizeTextarea = (ref, value, containerRef) => {
  useLayoutEffect(() => {
    const ta = ref.current;
    const container = containerRef?.current;

    if (!ta) return;

    // Save scroll position (in case user is typing mid-scroll)
    const prevScrollTop = ta.scrollTop;

    // Reset height to auto first to recalculate
    ta.style.height = 'auto';
    // Now set it to the scrollHeight
    ta.style.height = `${ta.scrollHeight}px`;

    // Restore scroll inside textarea
    ta.scrollTop = prevScrollTop;
  

    // Optional: scroll outer container to bottom if near end
    if (container) {
      const isAtBottom =
        Math.abs(container.scrollHeight - container.scrollTop - container.clientHeight) < 5;

      if (isAtBottom) {
        container.scrollTop = container.scrollHeight;
      }
    }
  }, [value]); // re-run whenever text changes
};
